/** @format */

import React, { useState, useEffect, useRef } from "react";
import { Carousel, Spin } from "antd";
// import imglogo from "../../../assets/common/logo.webp";
import imglogo from "../../../assets/common/logo_sunny.webp";

import { Divider } from "antd";
import { useNavigate } from "react-router-dom";
import ValueCard from "../../../components/card/ValueCard"; // Adjust the path as necessary
import { path } from "../../../utils/common/constant";
import ServiceCard from "../../../components/card/ServiceCard";
import { blogData, dataCardActivity } from "../../../models/mockdata";
import { CardBlog } from "../../../components";
import { List } from "antd";
import { services, values, imageCarousel } from "../../../models/mockdata";
import { withTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { getblogs } from "../../../services/blog";
import ActivitySection from "./ActivitySection";

import Home_Services_01 from "../../../assets/Home_Services_01.jpg";
import Home_Services_02 from "../../../assets/Home_Services_02.jpg";
import Home_Services_03 from "../../../assets/Home_Services_03.jpg";

const HomePage = (props) => {
  const { t } = props;

  const navigate = useNavigate();

  const [visibleBlogs, setVisibleBlogs] = useState(3);

  const [selectedValueCard, setSelectedValueCard] = useState(values[0]);

  console.log(selectedValueCard);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200 && window.innerWidth > 768) {
        setVisibleBlogs(2);
      } else {
        setVisibleBlogs(3);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderBannerSection = () => {
    return (
      <div className="w-full">
        <Carousel autoplay effect="fade" autoplaySpeed={3000}>
          {imageCarousel?.map((item, index) => {
            return (
              <div className="">
                <div className="w-full h-[calc(100vh-132px)]   relative transition-all duration-1000 ease-in-out">
                  <img
                    className={`w-full h-full absolute ${index === 1 ? "object-bottom" : index === 0 ? "object-top" : "object-center"}  object-cover top-0 left-0`}
                    src={item.src}
                  ></img>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  };

  const RenderValuesSection = () => {
    return (
      <div className="flex flex-col max-w-[1140px] qhd:max-w-[100%] md:pb-[100px] md:pt-[100px] qhd:pb-[150px] qhd:pt-[150px] items-center pvmax:max-dv:w-[85%]">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="text-[2rem] qhd:text-[2rem] font-bold text-primary_light mb-[0.8125rem] text-center"
        >
          {t("Home_Value")}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="text-[3rem] qhd:text-[3rem]  pb-[1.25rem] font-bold"
        >
          <span
            className="text-secondary1 uppercase"
            style={{ lineHeight: 1.25 }}
          >
            {"Sunny Pearl"}
          </span>
        </motion.div>

        <div className="w-full max-w-[1140px] qhd:max-w-[60%] mx-auto pt-[50px]">
          <div className="h-full grid grid-cols-1 gap-4 lg:grid-cols-5 qhd:gap-10">
            <div className={"col-span-1 space-y-4 lg:col-span-2"}>
              {values.map((value, index) => {
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 70 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                  >
                    <ValueCard
                      icon={value.icon}
                      title={t(value.title)}
                      description={t(value.description)}
                      index={index}
                      {...(value.onclick
                        ? {
                            onclick: () => {
                              setSelectedValueCard(value);
                              // navigate(value.path);
                            },
                          }
                        : {
                            onclick: () => {
                              setSelectedValueCard(value);
                            },
                          })}
                      className={`${value.title === selectedValueCard.title ? "bg-primary text-white" : "bg-white text-primary"}`}
                    />
                  </motion.div>
                );
              })}
            </div>
            <div className="col-span-1 flex items-stretch lg:col-span-3">
              <motion.div
                initial={{ opacity: 0, y: 70 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 }}
              >
                <img
                  src={selectedValueCard.thumbnail}
                  alt={selectedValueCard.thumbnail}
                  className={"w-full h-full object-cover"}
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderAboutSection = () => {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });

    return (
      <div className="max-w-[1140px]  qhd:max-w-[60%] mx-auto pr-4 py-[50px] pv:py-[70px] dv:py-[100px] qhd:py-[150px] pv:max-md:w-[85%]">
        <div className="grid grid-cols-1 pv:grid-cols-1 md:grid-cols-2  gap-6 items-center">
          {/* Left side - Image */}
          <div className="relative h-full ">
            <motion.div
              ref={ref}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: inView ? 1 : 0, opacity: inView ? 1 : 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="flex pv:max-ph:justify-center"
            >
              <img
                src={imglogo}
                alt="Sunny Pearl"
                className="w-[60%] rounded-lg"
              />
            </motion.div>
            {/* <div className="absolute bottom-[600px]  right-[150px] qhd:right-[200px] qhd:bottom-[500px] hidden ph:grid grid-cols-8 gap-2">
              {[...Array(64)].map((_, index) => (
                <div
                  key={index}
                  className="w-1.5 h-1.5  rounded-full bg-cyan-300 opacity-50"
                />
              ))}
            </div> */}
          </div>
          {/* Right side - Content */}
          <motion.div
            className="lg:col-span-1 flex flex-col "
            initial={{ opacity: 0 }}
            animate={{ opacity: inView ? 1 : 0 }}
            transition={{ duration: 0.3, ease: "easeInOut", delay: 0.3 }}
          >
            <span className="text-[2rem] qhd:text-[2rem] font-bold text-primary_light mb-[13px]">
              {t("Home_AboutUs")}
            </span>
            <h2
              className=" pb-[1.25rem] text-[2.5rem] qhd:text-[2.5rem]  font-medium text-primary leading-tight"
              style={{
                lineHeight: 1.25,
                fontWeight: 500,
              }}
            >
              {t("Home_AboutUsTitle")}
            </h2>
            <p
              className="text-[1.125rem] qhd:text-[1.125rem] whitespace-pre-line text-primary leading-relaxed text-justify"
              style={{ lineHeight: 1.6, fontWeight: 400 }}
            >
              {t("Home_AboutUsDescription")}
            </p>
            <button
              className="mt-[44px] qhd:mt-[60px]  flex items-center gap-3 bg-secondary1 text-white px-[42px] py-3 rounded-lg w-fit hover:bg-opacity-60 transition-colors"
              onClick={() => navigate("../" + path.common.ABOUT)}
            >
              <p
                className="text-[1rem] qhd:text-[1rem]"
                style={{ fontWeight: 600 }}
              >
                {t("SeeMore")}
              </p>
              <Icon
                icon="line-md:arrow-right"
                style={{ fontWeight: 600 }}
                className="font-bold text-[1rem] qhd:text-[1rem]"
              ></Icon>
            </button>
          </motion.div>
        </div>
      </div>
    );
  };

  const RenderBlogSection = () => {
    const [BlogsData, setBlogsData] = useState([]);
    const [IsloadingData, setIsloadingData] = useState(false);
    const pagesize = 6;
    const [totalPages, setTotalPages] = useState(1);

    const [currentPage, setCurrentPage] = useState(1);
    const getAllBlogs = async () => {
      try {
        const res = await getblogs(currentPage, pagesize);
        const validBlogs = res.data.filter(
          (item) => item.content && item.title && item.thumbnail
        ); // Lọc các mục hợp lệ
        setBlogsData(validBlogs); // Cập nhật state với dữ liệu hợp lệ
        setIsloadingData(false); // Tắt trạng thái loading
      } catch (err) {
        console.error(err.message);
        setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
      }
    };
    useEffect(() => {
      getAllBlogs();
    }, []);
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.3,
    });

    return (
      <div className="max-w-[1140px] qhd:max-w-[60%]  mx-auto gap-10 py-[50px] ph:py-[100px] qhd:py-[150px] rounded-lg w-full pvmax:max-dv:w-[85%] ">
        <div className="mx-auto ">
          <motion.div
            className="flex justify-between items-center pb-10"
            ref={ref}
            initial={{ opacity: 0 }}
            animate={{ opacity: inView ? 1 : 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <div className="flex flex-col  text-primary">
              {/* <p
                className="text-[1rem] mb-[0.8125rem] "
                style={{ fontWeight: 500 }}
              >
                {t("HomeBlog")}
              </p> */}
              <p
                className="text-[1.5rem] ph:text-[2.5rem] qhd:text-[2.5rem] "
                style={{ lineHeight: 1.25, fontWeight: 500 }}
              >
                {t("HomeBlogSubtitle")}
              </p>
            </div>
            <button
              className="inline-flex px-[42px]  items-center justify-center gap-2 bg-secondary1 hover:bg-opacity-60 text-white   rounded-[10px] transition-colors"
              onClick={() => navigate("../" + path.common.BLOG)}
            >
              <div className="h-[50px]  flex justify-center items-center ">
                <p
                  className="text-[1rem] qhd:text-[1rem]"
                  style={{ fontWeight: 500 }}
                >
                  {t("ViewAll")}
                </p>
              </div>
            </button>
          </motion.div>
        </div>

        {IsloadingData ? (
          <div className="flex justify-center">
            <Spin size="large"></Spin>
          </div>
        ) : blogData?.length > 0 ? (
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 1,
              md: 2,
              lg: 2,
              xl: 3,
              xxl: 3,
            }}
            dataSource={BlogsData?.slice(0, visibleBlogs)}
            renderItem={(item, index) => {
              // Kiểm tra nếu content, title, hoặc thumbnail bị null
              if (!item.content || !item.title || !item.thumbnail) {
                return null;
              }

              return (
                <List.Item key={index}>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: inView ? 1 : 0 }}
                    transition={{
                      duration: 0.2,
                      ease: "easeInOut",
                      delay: (index + 1) * 0.1,
                    }}
                  >
                    <CardBlog
                      id={item.id}
                      content={item.content}
                      creator_avatar={item.creator_avatar}
                      creator={item.creator}
                      category={item.category}
                      thumbnail={item.thumbnail}
                      title={item.title}
                      subtitle={item?.subtitle}
                    />
                  </motion.div>
                </List.Item>
              );
            }}
          />
        ) : (
          <></>
        )}
      </div>
    );
  };

  const RenderServiceSection = () => {
    return (
      <div className="flex items-center justify-center qhd:max-w-[100%] py-[50px] pv:py-[70px] dv:py-[100px] qhd:py-[150px] w-full bg-[#f8f8f8]">
        <div className="flex flex-col max-w-[1140px] qhd:max-w-[60%] pvmax:max-dv:w-[85%] items-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3 }}
            className="text-primary"
          >
            <p className="text-[2rem] qhd:text-[2rem] font-bold text-primary_light mb-[0.8125rem]">
              {t("Home_Service")}
            </p>
          </motion.div>

          <div className="grid grid-cols-1  pv:grid-cols-1 xl:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <ServiceCard
                  title={service.title}
                  imgUrl={service.img}
                  id={service.id}
                  description={service.description}
                  path={service.path}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const RenderContactSection = () => {
    const handleNavigateContact = () => {
      navigate("/contact");
    };
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });
    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.4 }}
        className="max-w-[1140px] w-[85%] qhd:max-w-[60%] mx-auto md:py-[50px]   "
      >
        <div className="bg-secondary1 rounded-[20px] py-16 qhd:py-16  sm:px-6 lg:px-8 text-center">
          <h2 className="text-[2.5rem] qhd:text-[2.5rem] font-semibold text-white ">
            {t("HomeContactTitle")}
          </h2>
          <p className="text-white text-[1rem]  qhd:text-[1rem] pt-[0.875rem] pb-[0.875rem] mb-[1rem] pvmax:max-ph:max-w-[90%] pvmax:max-ph:mx-auto">
            {t("HomeContactSubtitle")}
          </p>
          <button
            className="inline-block rounded-[10px] border-[2px] hover:bg-white hover:text-secondary1 border-white px-[42px] py-3  bg-transparent text-white transition-colors duration-200"
            onClick={handleNavigateContact}
          >
            <p className="text-[1rem] font-bold qhd:text-[1rem]">
              {t("HomeContactButton")}
            </p>
          </button>
        </div>
      </motion.div>
    );
  };

  const renderDivider = () => {
    return (
      <div className="w-1/2 ani_zoomIn max-w-[1140px] qhd:max-w-[60%] mx-[15px]  md:py-[50px]">
        <Divider className="bg-slate-300" />
      </div>
    );
  };

  const SuggestProduct = [
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-TA-HONG.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-MA-NAO-DO.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-MOONSTONE.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-TOC-XANH.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/07/TOC-NAU.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-AQUA.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/07/AQUA.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/07/APATITE.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/08/WEB-6LI-TA-VANG.png",
    },
    {
      img: "https://tinhlamjw.com/wp-content/uploads/2023/07/TOC-NAU.png",
    },
  ];

  return (
    <div className="w-full flex flex-col justify-center items-center">
      {renderBannerSection()}
      <RenderAboutSection />
      {/* {renderDivider()} */}
      <RenderServiceSection />
      <RenderValuesSection />

      {/* <ActivitySection /> */}

      <RenderBlogSection />
      <RenderContactSection />
    </div>
  );
};

export default withTranslation()(HomePage);
